/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartTypeMeasurementToolResponse
 */
export interface PartTypeMeasurementToolResponse {
    /**
     * 
     * @type {number}
     * @memberof PartTypeMeasurementToolResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartTypeMeasurementToolResponse
     */
    measurementToolId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartTypeMeasurementToolResponse
     */
    measurementTool?: string;
    /**
     * 
     * @type {number}
     * @memberof PartTypeMeasurementToolResponse
     */
    partTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartTypeMeasurementToolResponse
     */
    partType?: string;
    /**
     * 
     * @type {number}
     * @memberof PartTypeMeasurementToolResponse
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the PartTypeMeasurementToolResponse interface.
 */
export function instanceOfPartTypeMeasurementToolResponse(value: object): value is PartTypeMeasurementToolResponse {
    return true;
}

export function PartTypeMeasurementToolResponseFromJSON(json: any): PartTypeMeasurementToolResponse {
    return PartTypeMeasurementToolResponseFromJSONTyped(json, false);
}

export function PartTypeMeasurementToolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartTypeMeasurementToolResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'measurementToolId': json['measurementToolId'] == null ? undefined : json['measurementToolId'],
        'measurementTool': json['measurementTool'] == null ? undefined : json['measurementTool'],
        'partTypeId': json['partTypeId'] == null ? undefined : json['partTypeId'],
        'partType': json['partType'] == null ? undefined : json['partType'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function PartTypeMeasurementToolResponseToJSON(json: any): PartTypeMeasurementToolResponse {
    return PartTypeMeasurementToolResponseToJSONTyped(json, false);
}

export function PartTypeMeasurementToolResponseToJSONTyped(value?: PartTypeMeasurementToolResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'measurementToolId': value['measurementToolId'],
        'measurementTool': value['measurementTool'],
        'partTypeId': value['partTypeId'],
        'partType': value['partType'],
        'sortOrder': value['sortOrder'],
    };
}

